export default __webpack_public_path__ + "static/media/starwars.b06e529e.jpg";